const es = {
    '/': {
        title: '{brand} | Apuestas Deportivas, Casino en Vivo & Retiros Instantáneos',
        description: 'Tragamonedas, casino en vivo y apuestas deportivas en {brand}. Casino crypto con retiros instantáneos, juegos demostrablemente justos & soporte 24/7.'
    },
    '/casino': {
        title: 'Casino en Línea | Tragamonedas, Blackjack & Dealers en Vivo | {brand}',
        description: 'Tragamonedas, blackjack, ruleta & dealers en vivo en {brand}. Cientos de juegos, depósitos crypto rápidos & retiros instantáneos disponibles 24/7.'
    },
    '/sports': {
        title: 'Apuestas Deportivas en Línea | Apuestas Crypto & Cuotas | {brand}',
        description: 'Apuesta en deportes en {brand}. Cuotas competitivas en fútbol, baloncesto & más. Apuestas en vivo, apuestas crypto seguras & pagos rápidos.'
    },
    '/livecasino': {
        title: 'Casino en Vivo | Blackjack, Ruleta & Dealers en Directo | {brand}',
        description: 'Blackjack, ruleta & juegos de casino en vivo en {brand}. Dealers reales, streaming en HD & una amplia selección de mesas disponibles 24/7.'
    },
    '/slots': {
        title: 'Tragamonedas en Línea | Gran Variedad de Slots de Casino | {brand}',
        description: 'Una enorme colección de tragamonedas en {brand}. Máquinas clásicas, video slots & progresivas, todas jugables con crypto.'
    },
    '/vip': {
        title: 'Programa VIP | Recompensas Exclusivas y Beneficios | {brand}',
        description: 'El programa VIP de {brand}: recompensas exclusivas, bonificaciones personalizadas y soporte prioritario. Beneficios diseñados para jugadores leales.'
    },
    '/welcome-offer': {
        title: 'Bono de Bienvenida | Casino Crypto | {brand}',
        description: 'Descubre el bono de bienvenida de {brand}. Empieza con crypto y disfruta de beneficios exclusivos para nuevos jugadores.'
    },
    '/referral': {
        title: 'Programa de Referidos | Gana Recompensas | {brand}',
        description: 'Invita amigos a {brand} y gana recompensas cuando se unan y cumplan los requisitos. Comparte tu enlace y comienza a ganar.'
    },
    '/promotion-page': {
        title: 'Promociones | Bonos y Ofertas Especiales | {brand}',
        description: 'Explora todas las promociones activas en {brand}. Bonos, giros gratis y ofertas especiales para jugadores crypto.'
    },
    '/hotslots': {
        title: 'Slots Populares | Tragamonedas Más Jugadas | {brand}',
        description: 'Juega las tragamonedas más populares en {brand}. Los slots más calientes disponibles con crypto.'
    },
    '/newgames': {
        title: 'Juegos Nuevos | Últimos Juegos de Casino | {brand}',
        description: 'Descubre los últimos juegos de casino en {brand}. Nuevas tragamonedas, juegos en vivo y más, actualizado regularmente.'
    },
    '/populargames': {
        title: 'Juegos Populares | Los Más Jugados en el Casino | {brand}',
        description: 'Los juegos de casino más populares en {brand}. Desde tragamonedas hasta dealers en vivo, todos jugables con crypto.'
    },
    '/gameshows': {
        title: 'Game Shows | Casino con Shows en Vivo | {brand}',
        description: 'Disfruta los mejores game shows en vivo en {brand}. Presentadores reales, juegos únicos y grandes premios en tiempo real.'
    },
    '/table_games': {
        title: 'Juegos de Mesa | Blackjack, Ruleta & Baccarat | {brand}',
        description: 'Juega blackjack, ruleta, baccarat y más juegos de mesa en {brand}. Todo disponible con crypto.'
    },
    '/hotlive': {
        title: 'Casino en Vivo Popular | Juegos en Vivo Más Jugados | {brand}',
        description: 'Los juegos de casino en vivo más populares en {brand}. Juega con dealers reales en tiempo real.'
    },
    '/featurebuyin': {
        title: 'Slots con Compra de Bonus | Feature Buy-in | {brand}',
        description: 'Juega tragamonedas con opción de comprar el bonus en {brand}. Accede directamente al bonus round sin esperar.'
    }
};
export default es;
